<div class="cx-quantity">
  <label>{{ 'configurator.attribute.quantity' | cxTranslate }}</label>
  <cx-item-counter
    [allowZero]="quantityOptions.allowZero ?? false"
    [control]="quantity"
    [min]="quantityOptions.allowZero ? 0 : 1"
  ></cx-item-counter>
</div>
